// @flow
import HireFormModal from './HireFormModal';

export default HireFormModal;
